import { useEffect, useState } from 'react';
import { useMessagesContext } from '../context/messagesContext/useMessagesContext';
import CancelSchedulingConfirmationDialog from './dialog/CancelSchedulingConfirmationDialog';
import { useAppContext } from '../context';

const CancelScheduling: React.FC = (
  
) => {
  const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

  const { cancellationRequested, cancellationRequestHandled } = useMessagesContext();
  const { cancelScheduling } = useAppContext();

  function onCancelScheduling(): void {
    cancellationRequestHandled();
    setModalIsOpen(false);
    cancelScheduling();
  }

  function onContinueScheduling(): void {
    cancellationRequestHandled();
    setModalIsOpen(false);
  }

  useEffect(() => {
    setModalIsOpen(cancellationRequested);
  }, [cancellationRequested]);

  return (
    <>
      <CancelSchedulingConfirmationDialog
        isOpen={modalIsOpen}
        onCancelScheduling={onCancelScheduling}
        onContinueScheduling={onContinueScheduling}
      />
    </>
  );
};

export default CancelScheduling;
